<template>
  <div class="wrapper">
    <el-form
      ref="formData"
      :model="formData"
      :rules="rules"
      label-width="150px"
    >
      <el-row :gutter="20">
        <!--<el-col :span="8">
           <el-form-item prop="shipperName" label="发布方姓名">
              <el-input clearable v-model="formData.shipperName" @focus="Shipperlist()"></el-input>
            </el-form-item>
         </el-col>
         <el-col :span="8">
           <el-form-item prop="shipperIdNo" label="发布方身份证件号码">
              <el-input clearable v-model="formData.shipperIdNo"></el-input>
            </el-form-item>
         </el-col>
         <el-col :span="8">
           <el-form-item prop="shipperMobile" label="发布方身手机号码">
              <el-input clearable v-model="formData.shipperMobile"></el-input>
            </el-form-item>
         </el-col>
         <el-col :span="8">
           <el-form-item prop="countryCode" label="国籍">
              <el-select v-model="formData.industryCode" placeholder="请选择国籍" filterable clearable>
                <el-option
                  v-for="item in stateList"
                  :key="item.code"
                  :label="item.name"
                  :value="item.code"
                />
              </el-select>
            </el-form-item>
         </el-col>-->
        <el-col :span="8">
          <el-form-item prop="companyName" label="企业名称">
            <el-input
              v-model="formData.companyName"
              clearable
              placeholder="请选择企业"
              @focus="Shipperlist()"
            />
          </el-form-item>
        </el-col>
        <el-col :span="8">
          <el-form-item prop="companyPhone" label="企业手机电话号码">
            <el-input
              v-model="formData.companyPhone"
              clearable
              :disabled="true"
            />
          </el-form-item>
        </el-col>
        <el-col :span="8">
          <el-form-item prop="companyTaxId" label="企业纳税人识别号">
            <el-input
              v-model="formData.companyTaxId"
              clearable
              :disabled="true"
            />
          </el-form-item>
        </el-col>
        <!-- <el-col :span="8">
          <el-form-item prop="companyAddressCode" label="公司地址">
            <el-cascader
              ref="companyAddressCode"
              v-model="companyAddressCode"
              :options="options"
              disabled
              :props="{
                value: 'countyCode',
                label: 'countyName',
                children: 'children'
              }"
            />
          </el-form-item>
        </el-col> -->
        <el-col :span="8">
          <!-- TODO： -->
          <el-form-item prop="detailAddress" label="营业执照地址">
            <el-input v-model="formData.detailAddress" clearable disabled />
          </el-form-item>
        </el-col>
        <el-col :span="8">
          <el-form-item prop="legalPerson" label="法定代表人">
            <el-input v-model="formData.legalPerson" clearable disabled />
          </el-form-item>
        </el-col>
        <!-- <el-col :span="8">
          <el-form-item prop="registerCapital" label="注册资本">
            <el-input
              v-model="formData.registerCapital"
              maxlength="32"
              clearable
            />
          </el-form-item>
        </el-col>
        <el-col :span="8">
          <el-form-item prop="establishDate" label="成立日期">
            <el-date-picker
              v-model="formData.establishDate"
              clearable
              type="date"
              placeholder="选择日期时间"
              value-format="yyyy-MM-dd"
            />
          </el-form-item>
        </el-col> -->
        <el-col :span="8">
          <el-form-item prop="registerTime" label="平台注册时间">
            <el-date-picker
              v-model="formData.registerTime"
              clearable
              type="datetime"
              placeholder="选择日期时间"
              value-format="yyyy-MM-dd HH:mm:ss"
              disabled=""
            />
          </el-form-item>
        </el-col>
        <el-col :span="8">
          <el-form-item prop="myTaxOrgan" label="所属主管税务机关">
            <el-input v-model="formData.myTaxOrgan" clearable disabled />
          </el-form-item>
        </el-col>
        <!-- <el-col :span="8">
          <el-form-item label="企业类型" prop="companyType">
            <el-select
              v-model="formData.companyType"
              placeholder="请选择"
              clearable
            >
              <el-option
                v-for="item in companyTypeOptions"
                :key="item.value"
                :label="item.label"
                :value="item.value"
              />
            </el-select>
          </el-form-item>
        </el-col>
        <el-col :span="8">
          <el-form-item prop="businessScope" label="经营范围">
            <el-input
              v-model="formData.businessScope"
              clearable
              maxlength="255"
            />
          </el-form-item>
        </el-col> -->
        <el-col :span="24">
          <el-form-item label="营业执照" required>
            <div class="avatarList">
              <div v-for="(item, index) in imageList" :key="index" class="flex">
                <img class="avatar" :src="item" />
                <span class="el-upload-list__item-actions" @click.stop>
                  <span
                    class="el-upload-list__item-icon"
                    @click.stop="handlePictureCardPreview(index)"
                  >
                    <i class="el-icon-zoom-in" />
                  </span>
                </span>
              </div>
            </div>
            <el-dialog :visible.sync="showImageFlag">
              <img width="100%" :src="showImageUrl" alt />
            </el-dialog>
          </el-form-item>
        </el-col>
      </el-row>
      <vxe-modal
        v-model="tuteship"
        title="选择企业"
        width="800"
        height="80%"
        resize
      >
        <customer ref="ShipperlRef" @events="receive" />
      </vxe-modal>

      <div style="text-align:center">
        <el-form-item>
          <el-button type="primary" @click="onSubmit">
            提交
          </el-button>
        </el-form-item>
      </div>
    </el-form>
  </div>
</template>

<script>
import { taxShipper, getTaxShipper } from "@/api/Taxation";
import { getListDict } from "@/api/shipment";
import customer from "./customer.vue";
// import {validatePhone} from '@/utils/validate'
export default {
  components: {
    customer
  },
  data() {
    /*      var validatorPhone=(rule, value, callback)=>{
        validatePhone(value)? callback(): callback(new Error("手机号格式有误"));
      }*/
    return {
      code: "",
      formData: {
        legalPerson: "",
        shipperName: "",
        shipperCode: "",
        establishDate: "",
        registerTime: "",
        companyName: "",
        shipperIdNo: "",
        detailAddress: "",
        myTaxOrgan: "",
        companyPhone: "",
        companyTaxId: ""
      },
      //公司类型
      companyTypeOptions: [
        { label: "一般人", value: 0 },
        { label: "小规模", value: 1 }
      ],
      companyAddressCode: [],
      rules: {
        /*shipperName: [
            { required: true, message: "请输入姓名", trigger: "none" },
            { min: 2, message: '至少两个字符', trigger: 'blur' }
          ],
          shipperIdNo: [
            { required: true, message: "请输入身份证件号码", trigger: "blur" },
            { type: 'number', message: "请输入正确的身份证件号码", trigger: "blur" }
          ],
          shipperMobile: [
            { required: true, validator:validatorPhone,trigger: "blur"},
          ],*/
        /*          companyPhone: [
            { type: 'number', required: true, message: "请输入企业手机电话号码", trigger: "blur" }
          ],*/
        /*          companyTaxId: [
            { required: true, message: "请输入企业纳税人识别号", trigger: "blur" }
          ],*/
        companyName: [
          { required: true, message: "请输入企业名称", trigger: "change" }
        ],
        companyAddress: [
          { required: true, message: "请选择公司地址", trigger: "blur" }
        ],
        detailAddress: [
          {
            required: true,
            message: "请输入营业执照地址",
            trigger: "blur"
          }
        ],
        legalPerson: [
          { required: true, message: "请选择法定代表人", trigger: "blur" }
        ],
        registerCapital: [
          { required: true, message: "请输入注册资本", trigger: "blur" },
          { max: 32, message: "长度不超过32个字符", trigger: "blur" }
        ],
        establishDate: [
          { required: true, message: "请选择成立日期", trigger: "blur" }
        ],
        registerTime: [
          {
            required: true,
            message: "请选择企业在平台注册为服务发布方时间",
            trigger: "blur"
          }
        ],
        myTaxOrgan: [
          { required: true, message: "请输入所属主管税务机关", trigger: "blur" }
        ],
        companyType: [
          { required: true, message: "请选择企业类型", trigger: "blur" }
        ],
        businessScope: [
          { required: true, message: "请输入经营范围", trigger: "blur" }
        ],
        businessLicenseImg: [
          { required: true, message: "请上传企业营业执照照片", trigger: "blur" }
        ]
      },
      options: this.$store.state.components.areaOptions,
      imageList: [],
      fileList: [],
      stateList: [],
      tuteship: false,
      branchCode: "",
      showImageFlag: false,
      showImageUrl: ""
    };
  },
  created() {
    this.code = this.$route.query.code;
    // this.Seladdress()
    //  国家地区
    getListDict({ types: "stateCode" }).then(response => {
      this.stateList = response.data.filter(
        item => item.type === "stateCode"
      )[0]["dictList"];
    });
    if (this.code) {
      this.getInfo();
    }
  },
  methods: {
    async getInfo() {
      let response = await getTaxShipper(this.code);
      this.formData = response.data;
      this.imageList = [response.data.businessLicenseImg];
      this.companyAddressCode = [
        response.data.provinceCode,
        response.data.cityCode,
        response.data.countyCode
      ];
    },
    onSubmit() {
      this.$refs["formData"].validate(valid => {
        console.log("==============", valid);
        if (valid) {
          const rLoading = this.openLoading();
          let type = "post";
          if (this.code) type = "put";
          taxShipper(this.formData, type).then(response => {
            rLoading.close();
            if (response.status == "0") {
              this.$message({
                message: response.msg,
                type: "success"
              });
              this.$router.go(-1);
              // this.$store.state.tagsView.cachedViews.splice(-1)
              // this.$store.state.tagsView.visitedViews.splice(-1)
            }
          });
        } else {
          if (this.formData.companyName) {
            this.$message.warning("请前往【企业信息】补充相关信息");
          }
          return false;
        }
      });
    },
    // 托运人方法
    Shipperlist() {
      this.$refs.ShipperlRef.shipmentlist();
      this.tuteship = true;
      this.formData.shipperName = "";
      this.formData.shipperCode = "";
    },
    // 托运人子组件向父组件传值
    receive(data) {
      this.formData.shipperCode = data.partyCode;
      // this.formData.shipperName = data.userName;
      this.tuteship = false;
      // this.formData.establishDate = data.gmtCreated.slice(0,10);
      this.formData.registerTime = data.gmtCreated;
      this.formData.companyName = data.companyName;
      this.formData.legalPerson = data.legalName || "";
      this.formData.companyPhone = data.phone || "";
      this.formData.companyTaxId = data.businessLicenseImgNumber;
      this.formData.cityCode = data.cityCode;
      this.formData.detailAddress = data.address || "";
      this.formData.myTaxOrgan = data.myTaxOrgan || "";
      this.$nextTick(() => {
        this.$refs.formData.clearValidate([
          "detailAddress",
          "myTaxOrgan",
          "legalPerson",
          "registerTime",
          "companyName"
        ]);
      });
      this.companyAddressCode = [
        data.provinceCode,
        data.cityCode,
        data.countyCode
      ];
      this.imageList = [data.businessLicenseImg];
      this.formData.branchCode = data.branchCode;
      // this.formData.shipperIdNo = data.identificationNumber;
    },
    // 放大
    handlePictureCardPreview(index) {
      this.showImageUrl = this.imageList[index];
      this.showImageFlag = true;
    }
    // 公司地址
    // setCompanyAddressCode(value){
    //   let node = this.$refs.companyAddressCode.getCheckedNodes()[0]
    //   this.formData.cityCode = node.data.cityCode
    //   this.formData.companyAddress = node.path.join(',')
    // },
  }
};
</script>
<style scoped lang="scss">
.avatarList {
  display: flex;
  flex-wrap: wrap;
  justify-content: space-between;
  .flex {
    position: relative;
    width: 150px;
    height: 150px;
    margin-bottom: 10px;
    overflow: hidden;
  }
}
.avatar {
  width: 100%;
}
.el-upload-list__item-actions {
  position: absolute;
  display: flex;
  align-items: center;
  justify-content: center;
  width: 100%;
  height: 100%;
  left: 0;
  top: 0;
  text-align: center;
  color: #fff;
  opacity: 0;
  font-size: 20px;
  background-color: rgba(0, 0, 0, 0.5);
  transition: opacity 0.3s;
  &:hover {
    opacity: 1;
  }
  .el-upload-list__item-icon {
    cursor: pointer;
    margin: 0 10px;
  }
}
</style>
